// src/context/CareModalContext.js
import React, { createContext, useContext, useState } from "react";

const CareModalContext = createContext(null);

export const CareModalProvider = ({ children }) => {
  const [isBookCareOpen, setIsBookCareOpen] = useState(false);
  const [isJoinTeamOpen, setIsJoinTeamOpen] = useState(false);

  const openBookCare = () => setIsBookCareOpen(true);
  const closeBookCare = () => setIsBookCareOpen(false);

  const openJoinTeam = () => setIsJoinTeamOpen(true);
  const closeJoinTeam = () => setIsJoinTeamOpen(false);

  return (
    <CareModalContext.Provider
      value={{
        isBookCareOpen,
        openBookCare,
        closeBookCare,
        isJoinTeamOpen,
        openJoinTeam,
        closeJoinTeam,
      }}
    >
      {children}
    </CareModalContext.Provider>
  );
};

export const useCareModal = () => {
  const context = useContext(CareModalContext);
  if (!context) {
    throw new Error("useCareModal must be used within a CareModalProvider");
  }
  return context;
};
